<div class="congtainer">
    <div class="row">
        <div class="col-sm" style="text-align: center;">
            <br>
            <h1>HORARIOS</h1>       
        </div>
    </div>
</div>
<br>
<div class="container">
    <div class="row">
        <div class="col-sm" style="text-align: center;">
            <table class="table table-dark">
                <thead>
                  <tr>
                    <th scope="col">Lunes</th>
                    <th scope="col">Martes</th>
                    <th scope="col">Miercoles</th>
                    <th scope="col">Jueves</th>
                    <th scope="col">Viernes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>8 am a 9 am</td>
                    <td>8 am a 9 am</td>
                    <td>8 am a 9 am</td>
                    <td>8 am a 9 am</td>
                    <td>8 am a 9 am</td>
                  </tr>
                  <tr>
                    <label style="text-align: center;">Tarde</label>
                  </tr>
                  
                  <tr>
                    <td>4 pm a 5pm</td>
                    <td>4 pm a 5pm</td>
                    <td>4 pm a 5pm</td>
                    <td>4 pm a 5pm</td>
                    <td>4 pm a 5pm</td>
                  </tr>
                  <tr> 
                    <td>5 pm a 6 pm</td>
                    <td>5 pm a 6 pm</td>
                    <td>5 pm a 6 pm</td>
                    <td>5 pm a 6 pm</td>
                    <td>5 pm a 6 pm</td>
                  </tr>
                  <tr>
                    <label style="text-align: center;">Noche</label>
                  </tr>
                  <tr>
                    <td>7 pm a 8 pm</td>
                    <td>7 pm a 8 pm</td>
                    <td>7 pm a 8 pm</td>
                    <td>7 pm a 8 pm</td>
                    <td>7 pm a 8 pm</td>
                  </tr>
                </tbody>
              </table>
        </div>
    </div>
</div>